import { mapGetters } from 'vuex'

export const InvoiceDmtMixin = {
  data () {
    return {
      dmt: null
    }
  },
  computed: {
    ...mapGetters(['INVOICE_DMTS', 'INVOICE_DMTS_BY_ID'])
  },
  async mounted () {
    await this.$store.dispatch('GET_INVOICE_DMTS')
    this.dmt = this.INVOICE_DMTS[this.INVOICE_DMTS.length - 1]
  },
  methods: {
    getDmtString () {
      return this.dmt.data.dmtString
    },
    getDmtId () {
      return this.dmt.id
    },
    getDmtValue () {
      return this.dmt.data.dmt
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/InvoiceDmtMixin.js